import { useState, useEffect } from 'react'

const useDevicePixelRatio = () => {
    const [pixelRatio, setPixelRatio] = useState(null)

    useEffect(() => {
        const ratio = window.devicePixelRatio
        setPixelRatio(ratio)
    }, [])

    return pixelRatio
}

export default useDevicePixelRatio
